export default __webpack_public_path__ + "static/media/Circles3.ce730028.png";